export default __webpack_public_path__ + "static/media/gamepad.feb79ab6.svg";